<script lang="ts">
  import Navigation from "$components/navbar/index.svelte";
  import FooterComponent from "$components/footer/index.svelte";
  import type { LayoutData } from "./$types";
  import { navbarMode, INavMode } from "$lib/store/detect-view";
  // const IS_DEV = ["development", "staging"].includes(process.env.NODE_ENV || "");

  export let data: LayoutData;
  const { nav: navData, footer, socialMedia } = data;
</script>

{#if $navbarMode === INavMode.FULL}
  <header class={`header ${$navbarMode === INavMode.FULL ? "" : "reduce"}`}>
    <!-- Navbar -->
    <Navigation {navData} />
  </header>
{/if}
<!-- Body -->
<main>
  <slot />
</main>

<FooterComponent {footer} {socialMedia} />

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .header {
    margin-bottom: calc(46px + 54px); // 80px;

    @include desktop {
      margin-bottom: calc(46px + 82px); // 100px
    }
  }
  .reduce {
    margin-bottom: 46px;
  }
</style>
